import ContentGraphModel from '../models/ContentGraphModel';
import { midfieldDefaults } from './defaults';

const { env, ...otherDefaults } = midfieldDefaults;

export default {
    ...otherDefaults,
    model: ContentGraphModel,
    env: {
        ...env,
    },
    pathTemplate: `graphql/?operationName=getGamesByGamePks&query={query}&variables={variables}`,
};


